// src/contexts/UnitContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const UnitContext = createContext();

export const useUnit = () => useContext(UnitContext);

export const UnitProvider = ({ children }) => {
    const [unitSystem, setUnitSystem] = useState('metric'); // 'metric' or 'imperial'
    const [detectedCountry, setDetectedCountry] = useState(null);
    const [isRegionFetched, setIsRegionFetched] = useState(false);

    useEffect(() => {
        const fetchLocation = async () => {
            try {
                const response = await fetch('/api/location');
                const data = await response.json();
                if (data && data.countryCode && data.countryCode !== 'XX') {
                    setDetectedCountry(data.countryCode);
                    // Standard imperial countries: US, Liberia (LR), Myanmar (MM)
                    if (['US', 'LR', 'MM'].includes(data.countryCode)) {
                        setUnitSystem('imperial');
                    } else {
                        setUnitSystem('metric');
                    }
                }
            } catch (error) {
                console.error("Failed to fetch location for units:", error);
                // default metric
            } finally {
                setIsRegionFetched(true);
            }
        };

        fetchLocation();
    }, []);

    const toggleUnitSystem = () => {
        setUnitSystem(prev => prev === 'metric' ? 'imperial' : 'metric');
    };

    return (
        <UnitContext.Provider value={{ unitSystem, setUnitSystem, toggleUnitSystem, detectedCountry, isRegionFetched }}>
            {children}
        </UnitContext.Provider>
    );
};
